import {
    apiRequest,
    mertuaDetail,
    mertuaApprove
} from "../../../../../../services/adapters/kepegawaian/mertuaService"

class ApproveRepository {

    fetchDetail = async (query) => {
        return await apiRequest("get", mertuaDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", mertuaApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository